module.exports = __webpack_public_path__ + "img/academic-landing-lightbox.655ea355.png";